import $ from 'jquery';

function initialiseCompanyFormListener(id) {
  $(id.concat('_business_id')).change(function() {
    let selectedCompanyInfo = KR.company_information[$(this).val()];
    if (!selectedCompanyInfo) {
      selectedCompanyInfo = { data: {} };
    }
    var data = selectedCompanyInfo.data;
    $(id.concat('_first_name')).val(data['first_name'] || '');
    $(id.concat('_last_name')).val(data['last_name'] || '');
    $(id.concat('_phone_number')).val(data['phone_number'] || '');
    $(id.concat('_email')).val(data['email'] || '');
    $(id.concat('_address')).val(data['address'] || '');
    $(id.concat('_zip')).val(data['zip'] || '');
    $(id.concat('_city')).val(data['city'] || '');
    $(id.concat('_profession')).val(data['profession'] || '');
    $(id.concat('_accepts_disclosure_obligation')).val(data['accepts_disclosure_obligation'] || '');
    $(id.concat('_company_address')).val(data['company_address'] || '');
    $(id.concat('_company_zip')).val(data['company_zip'] || '');
    $(id.concat('_company_city')).val(data['company_city'] || '');
    $(id.concat('_company_country')).val(data['company_country'] || '');
    $(id.concat('_company_business_field')).val(data['company_business_field'] || '');
    $(id.concat('_company_bank_account')).val(data['company_bank_account'] || '');
    $(id.concat('_value_share_account')).val(data['value_share_account'] || '');
  });
}
document.addEventListener('turbo:load', function() {
  if ($('#agreement_company_business_id').length) {
    initialiseCompanyFormListener('#agreement_company');
  }
});
